import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';

import { msg } from '@lingui/core/macro';
import {
  expenditureFields,
  currencyQuantityField,
} from './common/expenditureFields';

export const expenditureMetadata = {
  displayName: msg({
    message: 'Expenses',
    context: 'Activity data schema name for expenditure',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...expenditureFields,
    // NOTE: quantity does not exist on the BAT but currency_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: currencyQuantityField,
  },
} as const satisfies BatMetadataConfigEntry;
